module.exports = __webpack_public_path__ + "img/settings.e995b506.svg";